"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

require("./styles.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Box = function Box(_ref) {
  var auto = _ref.auto,
      animated = _ref.animated,
      height = _ref.height,
      width = _ref.width,
      props = _objectWithoutProperties(_ref, ["auto", "animated", "height", "width"]);

  var classnames = ['react-skeletons__box'];
  var boxHeight = auto ? '100%' : height;
  var boxWidth = auto ? '100%' : width;
  animated ? classnames.push('react-skeletons__animation') : classnames.push('react-skeleton__base');
  return _react["default"].createElement("div", {
    className: classnames.join(' '),
    style: {
      height: boxHeight,
      width: boxWidth
    }
  });
};

Box.defaultProps = {
  auto: false,
  animated: true,
  height: 72,
  width: 72
};
var _default = Box;
exports["default"] = _default;